<template>
    <div>

        <v-dialog
                v-model="dialog"
                width="90%"
        >
            <v-card>
                <v-card-title>
                    Selecione a fonte desejada
                </v-card-title>
                <v-container fluid>
                    <v-row dense>
                        <v-col
                                cols="4"
                                v-for="(font, k) in aFontsFamily"
                                :key="k"
                        >
                            <v-card
                                    @click="update(font)"
                                    class="fill-height"
                            >
                                <v-card-title>
                                    {{getFontLabel(font)}}
                                </v-card-title>

                                <v-card-text>
                                    <p
                                            class="text-h4"
                                            :style="{fontFamily: font}"
                                    >
                                        Eu sou um lindo texto de exemplo! R$123.45678,90
                                    </p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="primary darken-1"
                            text
                            @click="dialog = false"
                    >
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-row dense no-gutters>
            <v-col>
                <v-btn
                        small
                        depressed
                        style="border: 1px gray solid"
                        @click="dialog = true"
                >
                    <v-icon>
                        mdi-format-font
                    </v-icon>
                </v-btn>
            </v-col>
            <!--            <v-col cols="8">-->
            <!--                <v-select-->
            <!--                        :value="value"-->
            <!--                        :items="aFontsFamily"-->
            <!--                        label="Fonte"-->
            <!--                        return-object-->
            <!--                        single-line-->
            <!--                        hide-details-->
            <!--                        dense-->
            <!--                ></v-select>-->
            <!--            </v-col>-->
        </v-row>

    </div>
</template>

<script>
    export default {
        name: "FontChooser",
        props: {
            value: {
                type: String,
                required: false
            },
        },

        data() {
            return {
                dialog: false,

                fontFamily: "",
                aFontsFamily: [
                    "'roboto', sans-serif !important",
                    "'Akronim', cursive !important",
                    "'Allerta', sans-serif !important",
                    "'Allerta Stencil', sans-serif !important",
                    "'Almendra', serif !important",
                    "'Arbutus', cursive !important",
                    "'Bangers', cursive !important",
                    "'Barriecito', cursive !important",
                    "'Barrio', cursive !important",
                    "'Berkshire Swash', cursive !important",
                    "'Black And White Picture', sans-serif !important",
                    "'Black Ops One', cursive !important",
                    "'Bubblegum Sans', cursive !important",
                    "'Bungee', cursive !important",
                    "'Bungee Hairline', cursive !important",
                    "'Bungee Inline', cursive !important",
                    "'Bungee Outline', cursive !important",
                    "'Bungee Shade', cursive !important",
                    "'Butcherman', cursive !important",
                    "'Cabin Sketch', cursive !important",
                    "'Caesar Dressing', cursive !important",
                    "'Calligraffitti', cursive !important",
                    "'Cedarville Cursive', cursive !important",
                    "'Chewy', cursive !important",
                    "'Cinzel Decorative', cursive !important",
                    "'Codystar', cursive !important",
                    "'Cookie', cursive !important",
                    "'Creepster', cursive !important",
                    "'Croissant One', cursive !important",
                    "'Delius Swash Caps', cursive !important",
                    "'Diplomata', cursive !important",
                    "'Eagle Lake', cursive !important",
                    "'Eater', cursive !important",
                    "'Economica', sans-serif !important",
                    "'Emilys Candy', cursive !important",
                    "'Ewert', cursive !important",
                    "'Faster One', cursive !important",
                    "'Fontdiner Swanky', cursive !important",
                    "'Freckle Face', cursive !important",
                    "'Fredericka the Great', cursive !important",
                    "'Frijole', cursive !important",
                    "'Gabriela', serif !important",
                    "'Gloria Hallelujah', cursive !important",
                    "'Grand Hotel', cursive !important",
                    "'Griffy', cursive !important",
                    "'Gugi', cursive !important",
                    "'Hanalei', cursive !important",
                    "'Handlee', cursive !important",
                    "'Hanuman', serif !important",
                    "'Henny Penny', cursive !important",
                    "'Herr Von Muellerhoff', cursive !important",
                    "'Holtwood One SC', serif !important",
                    "'Homemade Apple', cursive !important",
                    "'Jacques Francois Shadow', cursive !important",
                    "'Josefin Slab', serif !important",
                    "'Jua', sans-serif !important",
                    "'Kelly Slab', cursive !important",
                    "'Kranky', cursive !important",
                    "'Kristi', cursive !important",
                    "'Lato', sans-serif !important",
                    "'Lemonada', cursive !important",
                    "'Libre Barcode 128', cursive !important",
                    "'Libre Barcode 128 Text', cursive !important",
                    "'Life Savers', cursive !important",
                    "'Londrina Outline', cursive !important",
                    "'Londrina Shadow', cursive !important",
                    "'Love Ya Like A Sister', cursive !important",
                    "'Major Mono Display', monospace !important",
                    "'Marck Script', cursive !important",
                    "'Megrim', cursive !important",
                    "'Monofett', cursive !important",
                    "'Monoton', cursive !important",
                    "'Montserrat', sans-serif !important",
                    "'Montserrat Alternates', sans-serif !important",
                    "'Mountains of Christmas', cursive !important",
                    "'Mr De Haviland', cursive !important",
                    "'Mystery Quest', cursive !important",
                    "'Nanum Brush Script', cursive !important",
                    "'Nosifer', cursive !important",
                    "'Oleo Script Swash Caps', cursive !important",
                    "'Open Sans', sans-serif !important",
                    "'Overpass Mono', monospace !important",
                    "'Parisienne', cursive !important",
                    "'Peralta', cursive !important",
                    "'Petit Formal Script', cursive !important",
                    "'Philosopher', sans-serif !important",
                    "'Piedra', cursive !important",
                    "'Playfair Display SC', serif !important",
                    "'Poiret One', cursive !important",
                    "'Press Start 2P', cursive !important",
                    "'Princess Sofia', cursive !important",
                    "'Qwigley', cursive !important",
                    "'Rochester', cursive !important",
                    "'Rye', cursive !important",
                    "'Sail', cursive !important",
                    "'Sancreek', cursive !important",
                    "'Schoolbell', cursive !important",
                    "'Sedgwick Ave', cursive !important",
                    "'Shojumaru', cursive !important",
                    "'Snowburst One', cursive !important",
                    "'Sofia', cursive !important",
                    "'Special Elite', cursive !important",
                    "'Spirax', cursive !important",
                    "'Stardos Stencil', cursive !important",
                    "'The Girl Next Door', cursive !important",
                    "'Trade Winds', cursive !important",
                    "'Ultra', serif !important",
                    "'Uncial Antiqua', cursive !important",
                    "'UnifrakturCook', cursive !important",
                    "'UnifrakturMaguntia', cursive !important",
                    "'Unkempt', cursive !important",
                    "'Vast Shadow', cursive !important",
                    "'VT323', monospace !important",
                    "'Wallpoet', cursive !important",
                    "Walter Turncoat', cursive !important",
                ],
            }
        },

        methods: {
            update: function (font) {
                this.$emit('input', font);
                this.dialog = false;
            },

            getFontLabel(font) {
                let fontLabel = "";
                let aAux = [];
                fontLabel = font.replace(/'/g, "");
                aAux = fontLabel.split(",");
                fontLabel = aAux[0];

                return fontLabel;
            }
        },
    }
</script>
